export class DocumentDoesNotExistError extends Error {
  static type = 'DocumentDoesNotExist'

  type: string

  constructor(message: string) {
    super(message)

    this.type = DocumentDoesNotExistError.type

    // Set the prototype explicitly.
    Object.setPrototypeOf(this, DocumentDoesNotExistError.prototype)
  }
}
